import React, { Component } from 'react';
import {
    NavLink,
    NavItem,
    Nav,
    Input,
    Button,
    ButtonGroup,
} from 'reactstrap';
import { notify } from 'react-notify-toast';

class OrderPanel extends Component {
    state = {
        marketEmpty: false,
        information: {
            amount: null,
            price: 0,
            name: '',
        },
        empty: {
            name: true,
            amount: true,
            price: true,
        },
        submitted: false,
        activeTab: 'bid',
        panelVisible: true,
        type: 'sell',
        tradeType: 'exchange'
    }

    uuidv4 = () => {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          // eslint-disable-next-line no-mixed-operators
          var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
    }

    handleChange = (field, value) => {
        this.setState({
            information: {
                ...this.state.information, // might cause a bug, change to prev state later
                [field]: value,
            },
            empty: {
                ...this.state.empty,
                [field]: !(value.toString().length > 0),
            },
            submitted: false
        });
    };

    formatNumber = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };

    calculateValue = (amount, price) => {
        // remove any ',' from the amount value
        amount = parseInt(amount.toString().replace(/\W/g, ''));
        return this.formatNumber((amount * price).toFixed(2));
    };

    tradeValue = (amount, tab) => {
        let value = 0;
        let amountRemaining = amount;
        let position = 0;

        if(this.state.tradeType === 'exchange') {
            let data = (tab === 'hit') ? this.props.bidData : this.props.askData;

            while(amountRemaining > 0 && position < data.length) {
                const trade = data[position].trade
    
                if(amountRemaining - parseInt(trade.amount) < 0) {
                    // the trade cannot be fully encapsulated
                    value += (amountRemaining * parseFloat(trade.price))
                    amountRemaining = 0
                } else {
                    // the trade can be fully fulfilled
                    value += (parseInt(trade.amount) * parseFloat(trade.price))
                    amountRemaining -= parseInt(trade.amount)
                }
    
                position += 1;
            }
    
            if(position === data.length && amountRemaining > 0) {
                return -1 * value;
            }
        } else {
            const amount = parseInt(this.state.information.amount)
            const price = parseFloat(this.state.information.price)

            if(!isNaN(price) && !isNaN(amount)) {
                value = amount * price
            }
        }
        
        return value;
    }

    fillOrder = () => {
        let amountRemaining = this.state.information.amount;
        let position = 0;
        let data = (this.state.activeTab === 'hit') ? this.props.bidData : this.props.askData;
        let orders = [];

        if(this.state.tradeType === 'exchange') {
            while(amountRemaining > 0 && position < data.length) {
                const trade = data[position].trade
    
                // console.log(data[position])
                if(trade.amount > 0) {
                    if(amountRemaining - parseInt(trade.amount) < 0) {
                        // the trade cannot be fully encapsulated
                        // value += (amountRemaining * parseFloat(trade.price))
                    
                        orders.push({
                            tradeID: trade.key,
                            amount: amountRemaining,
                            price: trade.price,
                            company: this.props.company,
                            tradeUID: trade.fromUID,
                            type: this.state.type,
                            counterparty: this.state.information.name
                        });
                        
                        amountRemaining = 0
                    } else {
                        // the trade can be fully fulfilled
                        // value += (parseInt(trade.amount) * parseFloat(trade.price))
        
                        orders.push({
                            tradeID: trade.key,
                            amount: parseInt(trade.amount),
                            price: trade.price,
                            company: this.props.company,
                            tradeUID: trade.fromUID,
                            type: this.state.type,
                            counterparty: this.state.information.name
                        });
                        
                        amountRemaining -= parseInt(trade.amount)
                    }
                }
    
                position += 1;
            }
        } else {
            // add OTC order
            orders.push({
                tradeID: this.uuidv4(),
                amount: this.state.information.amount,
                price: this.state.information.price,
                company: this.props.company,
                tradeUID: this.props.uid,
                type: this.state.type,
                counterparty: this.state.information.name
            });
            console.log('going to the otc!')
        }

        const tradeValue = this.tradeValue(this.state.information.amount, this.state.activeTab);

        // let insufficientFunds = false;
        // let insufficientStock = false;

        if(tradeValue > this.props.availableFunds && this.state.activeTab === 'hit') {
            notify.show('Unable to process transaction due to insufficient funds.', 'error');
        } else if(tradeValue > 0) {
            this.props.fillOrder(orders, this.props.uid);
            this.resetForm();
        } else {
            notify.show('Unable to process transaction as market is empty.', 'error');
        }
    }

    executeTrade = () => {
        this.setState({  submitted: true });

        if(!this.state.empty.amount && !this.state.empty.price) {
            const information = this.state.information;
            information.type = this.state.type;

            let isBest = false;

            const price = parseFloat(information.price);

            if(this.state.activeTab === 'ask') {
                isBest = this.props.askMinimum > price
            } else if(this.state.activeTab === 'bid') {
                isBest = this.props.bidMaximum < price
            }

            let info = this.state.information;

            info.amount = parseInt(info.amount);

            const tradeValue = info.amount * price;

            if(tradeValue > this.props.availableFunds && this.state.activeTab === 'bid') {
                notify.show('Unable to process bid due to insufficient funds.', 'error');
            } else {
                this.props.newTrade(info, this.props.company, isBest);
                this.resetForm();
            }
        }
    }

    resetForm = () => {
        this.setState({
            information: {
                ...this.state.information,
                counterparty: '',
                amount: null,
                price: 0,
            },
            empty: {
                name: true,
                amount: true,
                price: true,
            },
            submitted: false,
        });
    }

    formatNumber = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    render() {
        let buttonText = "";

        if(this.state.activeTab === 'hit') {
            buttonText = 'Hit Bid';
        } else if (this.state.activeTab === 'lift') {
            buttonText = 'Lift Ask';
        } else if (this.state.activeTab === 'bid') {
            buttonText = 'Book';
        } else {
            buttonText = 'Book';
        }

        const linkCss = {background: 'transparent', color: '#7AD6BA', border: 'none', borderBottom:'3px solid #7AD6BA'};

        const tradeValue = this.tradeValue(this.state.information.amount, this.state.activeTab);
        let formattedTradeValue = '$0.00';
        let marketEmpty = false;

        if(this.state.information.amount > 0) {
            if(tradeValue < 0) {
                formattedTradeValue ='$' + this.formatNumber(Math.abs(tradeValue.toFixed(2)))
                marketEmpty = true;
            } else {
                formattedTradeValue = '$' + this.formatNumber(tradeValue.toFixed(2))
            }
        }

        return (
            <div className={ 'orderStock' }>
                <div>
                    <h4 id={ 'darkTextBackground' }>
                        Order
                    </h4>
                </div>
                <Nav tabs className={!this.state.panelVisible ? 'tabsHidden dark' : 'dark'} >
                    <NavItem>
                        <NavLink style={(this.state.activeTab === 'bid' ? 'active' : '') ? linkCss : {}} className={"orderTab " + (this.state.activeTab === 'bid' ? 'active' : '')} onClick={(e) => this.setState({ activeTab: 'bid', type: 'sell', tradeType: '' })}>
                            Bid
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink style={(this.state.activeTab === 'ask' ? 'active' : '') ? linkCss : {}} className={"orderTab " + (this.state.activeTab === 'ask' ? 'active' : '')} onClick={(e) => this.setState({ activeTab: 'ask', type: 'buy', tradeType: '' })}>
                            Ask
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink style={(this.state.activeTab === 'hit' ? 'active' : '') ? linkCss : {}} className={"orderTab " + (this.state.activeTab === 'hit' ? 'active' : '')} onClick={(e) => this.setState({ activeTab: 'hit', type: 'sell' })}>
                            Hit
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink style={(this.state.activeTab === 'lift' ? 'active' : '') ? linkCss : {}} className={"orderTab " + (this.state.activeTab === 'lift' ? 'active' : '')} onClick={(e) => this.setState({ activeTab: 'lift', type: 'buy' })}>
                            Lift
                        </NavLink>
                    </NavItem>
                </Nav>
                <div className="orderStockBody">
                    <div className="tradeCalculation">
                        <Input
                            style={{background: 'transparent', color: 'white', border: '1px solid rgb(222, 226, 230, 0.1)'}}
                            className={ (this.state.submitted && this.state.empty.amount) ? 'required animated pulse faster' : ''} 
                            placeholder={"# Amount"} 
                            value={(this.state.information.amount !== null ) ? this.state.information.amount : ''} 
                            onChange={(e) => (!isNaN(e.target.value)) ? this.handleChange('amount', e.target.value) : ''} />
                        { ((this.state.activeTab === 'bid' || this.state.activeTab === 'ask') || this.state.tradeType === 'otc') ?
                        <Input
                            style={{marginLeft: 15, background: 'transparent', color: 'white', border: '1px solid rgb(222, 226, 230, 0.1)'}}
                            className={ this.state.submitted && this.state.empty.price ? 'required animated pulse faster' : '' }
                            placeholder="($) Price"
                            value={ this.state.information.price !== 0 ? this.state.information.price : '' }
                            onChange={(e) => !isNaN(e.target.value.toString().replace('$', '')) ? this.handleChange('price', e.target.value.toString().replace('$', '')) : ''}
                        /> : '' }
                    </div>
                    <div className="tradeValue">
                        <div>
                            <span>Trade Value: </span>
                            { (this.state.activeTab === 'hit' || this.state.activeTab === 'lift') ? 
                                <span className={((marketEmpty) ? "small_money red" : "small_money green")}>
                                    { formattedTradeValue }
                                </span>
                            : 
                                <span className="small_money green">
                                    ${ this.formatNumber((this.state.information.price * this.state.information.amount).toFixed(2)) }
                                </span>
                            }
                        </div>
                    </div>
                    { (this.state.activeTab === 'hit' || this.state.activeTab === 'lift') ?
                    <div className="tradeType">
                        <ButtonGroup>
                            <Button
                                color="primary"
                                onClick={() => this.setState({ tradeType: 'exchange' })}
                                active={this.state.tradeType === 'exchange'}>
                                Exchange
                            </Button>
                            <Button
                                color="primary"
                                onClick={() => this.setState({ tradeType: 'otc' })}
                                active={this.state.tradeType === 'otc'}>
                                OTC
                            </Button>
                        </ButtonGroup>
                    </div> : ''}
                    { (this.state.tradeType === 'otc') ?
                        <Input
                        style={{marginRight: 15, background: 'transparent', color: 'white', border: '1px solid rgb(222, 226, 230, 0.1)'}}
                        className={"counterparty " + ((this.state.submitted && this.state.empty.name) ? 'required animated pulse faster' : '')}
                        type="text" 
                        name="counterparty"
                        placeholder="Counterparty:"
                        value={this.state.information.name} 
                        onChange={(e) => this.handleChange('name', e.target.value.toString().toUpperCase())} />
                    : '' }
                    <Button 
                    disabled={this.state.information.amount > 0 ? false : true} 
                    color="success" 
                    style={{ width: '100%', opacity: (this.state.information.amount > 0) ? '1.0' : '0.50' }} 
                    onClick={(e) => (this.state.activeTab === 'hit' || this.state.activeTab === 'lift') ? this.fillOrder() : this.executeTrade() }>{ buttonText }</Button>
                </div>
            </div>
        );
    }
}

export default OrderPanel;
